export const VERIFICATION_REMINDERS_FIELD_MAX_LENGTH = {
  payerName: 100,
  domainOrEmailAmount: 10,
  domainOrEmailLength: 255,
};